<div class="section-header">
    <div class="title">
        Hinzugefügtes Verbrauchsmaterial
    </div>

    <button class="pr-btn-primary" (click)="onAddAccessoryItems()" type="button">
        <bd-fa [name]="'plus'"></bd-fa>
        <span>Verbrauchsmaterial hinzufügen</span>
    </button>
</div>


<div class="table" [ngClass]="{'invalid': showValidationError()}">
    <div class="table-header" [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLIES)}">
        <div class="table-column">Anzahl</div>
        <div class="table-column">Artikel</div>
    </div>

    <div class="no-content-info"
         *ngIf="!model.containsSomeStep5PurchaseContainers()">
        Noch kein Verbrauchsmaterial hinzugefügt.
    </div>
    <div class="table-body"
         *ngIf="model.containsSomeStep5PurchaseContainers()">

        <ng-container
            *ngFor="let productContainer of model.requestedPreselectedGeneralDevicesWithSupplyContainers; let i = index">

            <div class="table-row">

                <div class="amount-column-cell amount-gsst">
                    <app-amount-input [(ngModel)]="productContainer.deviceAmount.amount" [showIcon]="false"
                                      [name]="productContainer.id + 'amount_gsst'"
                                      [forceFormValidationVisibility]="forceFormValidationVisibility" disabled>
                    </app-amount-input>
                </div>

                <div class="column-article-cell device">
                    <div class="label-container">
                        <app-product-label [orderItemContainer]="productContainer" [showTitle]="false">
                        </app-product-label>
                    </div>
                </div>


                <div class="button-cell">
                    <!--                    <button (click)="onDeviceCancelBtnClicked( productContainer )" type="button">-->
                    <!--                        <bd-fa-button [name]="'times'"></bd-fa-button>-->
                    <!--                    </button>-->
                </div>


            </div>

            <!--            when itemToOrder contains supplies ,so add also rows for each of them -->
            <div class="table-row supply" *ngFor="let supplyContainer of productContainer.supplies">

                <div class="amount-column-cell">
                    <app-amount-input [(ngModel)]="supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount"
                                      [showIcon]="false" [name]="supplyContainer.id + 'amount_gsst'" [minNumber]="0"
                                      [bdMinNumber]="1"
                                      [ngClass]="{'warning':showAmountWarning( supplyContainer,  model.project )}"
                                      [forceFormValidationVisibility]="forceFormValidationVisibility" required
                                      #dynamicInput="ngModel">
                    </app-amount-input>
                </div>


                <div class="column-article-cell">
                    <div class="label-container">
                        <app-product-label [orderItemContainer]="supplyContainer"></app-product-label>
                    </div>
                </div>

                <div class="warning-column-cell" >
                    <bd-fa-button [name]="'warning'" (mouseenter)="openAmountInfoPanel( anchor )"
                                  (mouseleave)="closeInfoPanel()"
                                  *ngIf="showAmountWarning( supplyContainer,  model.project )">
                    </bd-fa-button>
                    <span class="anchor" #anchor> </span>

                </div>

                <div class="button-cell">
                    <button (click)="onCategorizedSupplyCancelBtnClicked( supplyContainer )" type="button">
                        <bd-fa-button [name]="'times'"></bd-fa-button>
                    </button>
                </div>

            </div>


        </ng-container>

        <!--no parent supplies-->
        <ng-container
            *ngIf="model?.requestedGeneralNoCategorisedSupplyContainers?.length">
            <div class="table-row category">
                <div class="no-parent-title">
                    <div>Verbrauchsmaterialien ohne Geräte</div>
                </div>
            </div>

            <div class="table-row supply supply-no-parrent"
                 *ngFor="let supplyContainer of model.requestedGeneralNoCategorisedSupplyContainers">

                <div class="amount-column-cell">
                    <app-amount-input [(ngModel)]="supplyContainer.noParentGeneralSupplyAmount.amount"
                                      [showIcon]="false" [incrementViaMouseWheel]="false"
                                      [name]="supplyContainer.id + 'amount_gsst'"
                                      [minNumber]="0" [bdMinNumber]="1" required
                                      [forceFormValidationVisibility]="forceFormValidationVisibility"
                                      #dynamicInput="ngModel">

                    </app-amount-input>

                </div>

                <div class="column-article-cell">
                    <div class="label-container">
                        <app-product-label [orderItemContainer]="supplyContainer"></app-product-label>
                    </div>
                </div>



                <div class="warning-column-cell">
                </div>

                <div class="button-cell">
                    <button (click)="onNoCategorySupplyCancelBtnClicked( supplyContainer )" type="button">
                        <bd-fa-button [name]="'times'"></bd-fa-button>
                    </button>
                </div>

            </div>

        </ng-container>

    </div>
</div>


<div class="error-viewer" *ngIf="showValidationError()">
    Bitte wählen Sie unter Schritt 3, 4 oder 5 mindestens ein Produkt aus.
</div>
